// extracted by mini-css-extract-plugin
export default {"brandPromo":"CF-z","carousel":"DF-z"};